// Shared framer-motion variants
export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 },
  }),
};

export const maskReveal = {
  hidden: { opacity: 0, y: 60, clipPath: "inset(0 0 100% 0)" },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    clipPath: "inset(0 0 0% 0)",
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.06 },
  }),
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.94 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export const PIXEL_COLORS = ["#f59e0b", "#ec4899", "#8b5cf6", "#3b82f6", "#06b6d4"];
